import * as types from './types'

export const actions = {
	getDownloadFileAction: (payload) => ({
		type: types.DOWNLOAD_DOC,
	}),

	getDownloadFileActionDone: (payload) => ({
		type: types.DOWNLOAD_DOC_DONE,
		payload,
	}),

	getDownloadFileActionFail: (payload) => ({
		type: types.DOWNLOAD_DOC_FAIL,
	}),


	deleteDataAction: (payload) => ({
		type: types.DELETE_DATA,
	}),

	deleteDataActionDone: (payload) => ({
		type: types.DELETE_DATA_DONE,
		payload,
	}),

	deleteDataActionFail: (payload) => ({
		type: types.DELETE_DATA_FAIL,
	}),


	setXmlAction: (payload) => ({
		type: types.SET_XML,
	}),

	setXmlActionDone: (payload) => ({
		type: types.SET_XML_DONE,
		payload,
	}),

	setXmlActionFail: (payload) => ({
		type: types.SET_XML_FAIL,
	}),


	getSpoListAction: (payload) => ({
		type: types.GET_SPO_LIST,
	}),

	getSpoListActionDone: (payload) => ({
		type: types.GET_SPO_LIST_DONE,
		payload,
	}),

	getSpoListActionFail: (payload) => ({
		type: types.GET_SPO_LIST_FAIL,
	}),
}
